import React from 'react'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'

const MiscRecordDetailHistoryDrawerContent = ({ historyConfig, onChange }) => {
  return (
    <div className="misc-record-detail-history-drawer-content">
      <Checkbox
        label="Is Enabled"
        checked={historyConfig.IsEnabled}
        onChange={(val) => onChange({ ...historyConfig, IsEnabled: val })}
      />
      <Checkbox
        label="Is Voidable"
        checked={historyConfig.IsVoidable}
        onChange={(val) => onChange({ ...historyConfig, IsVoidable: val })}
      />
      <Checkbox
        label="Show Changed From/Changed To"
        checked={historyConfig.ShowChangedFromTo}
        onChange={(val) => onChange({ ...historyConfig, ShowChangedFromTo: val })}
      />
      <Checkbox
        label="Allow Correspondence Downloads"
        checked={historyConfig.AllowCorrespondenceDownloads}
        onChange={(val) => onChange({ ...historyConfig, AllowCorrespondenceDownloads: val })}
      />
    </div>
  )
}

export default MiscRecordDetailHistoryDrawerContent
